import axios from "axios";
import ApiCoreService from "./api.core.service";

const API_BASE_URL = "https://api.voltbrew.energy";

export default class ChatService extends ApiCoreService {
  static async listMessages(userId) {
    if (!userId) {
      throw new Error("Invalid userId");
    }
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/chat/list/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
          withCredentials: true,
        }
      );
      const messages = response?.data?.messages || [];
      return {
        messages: messages.sort((a, b) => a.createdAt - b.createdAt),
      };
    } catch (error) {
      throw new Error("Failed to fetch messages");
    }
  }

  static async postMessage(userId, payload) {
    if (!userId) {
      throw new Error("Invalid userId");
    }
    const message = payload?.message?.trim();
    if (!message) {
      throw new Error("message is required");
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/chat/list/${userId}/ask`,
        {
          message,
          actor: payload?.actor || "USER",
          widgetType: payload?.widgetType,
          data: payload?.data,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      throw new Error("Failed to save message");
    }
  }
}
